"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardSelector = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _polished = require("polished");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n        ", ";\n      "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        width: auto;\n        height: auto;\n        display: grid;\n        grid-template-columns: 40px auto;\n        grid-gap: 10px;\n        text-align: left;\n        padding: 15px 10px;\n\n        & .flexi-selector-checker {\n          max-height: 40px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          & i {\n            display: inline-flex;\n            width: 24px;\n            height: 24px;\n            color: rgba(255,255,255,0);\n            background: none;\n            border: 2px solid ", ";\n            border-radius: 50%;\n            align-items: center;\n            justify-content: center;\n            transform: scale(1);\n            transition: all 0.2s ease-out;\n          }\n        }\n        & .flexi-selector-children{\n          padding: 5px 0 0;\n          grid-column: 1 / span 2;\n        }\n        & .flexi-selector-label {\n          padding: 5px 0 0;\n          font-weight: bold;\n          transition: all 0.2s ease-out;\n\n          & img {\n            max-width: 90%;\n            max-height: ", ";\n          }\n        }\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        width: auto;\n        height: auto;\n        display: grid;\n        grid-template-columns: minmax(40px, max-content) auto;\n        grid-gap: 10px;\n        text-align: left;\n        padding: 15px 10px;\n\n        & .flexi-selector-checker {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          & i {\n            display: inline-flex;\n            width: 24px;\n            height: 24px;\n            color: rgba(255,255,255,0);\n            background: none;\n            border: 2px solid ", ";\n            border-radius: 50%;\n            align-items: center;\n            justify-content: center;\n            transform: scale(1);\n            transition: all 0.2s ease-out;\n          }\n        }\n        & .flexi-selector-description {\n          padding: 5px 0 0;\n          opacity: 0.8;\n        }\n        & .flexi-selector-label {\n          padding: 5px 0 0;\n          font-weight: bold;\n          transition: all 0.2s ease-out;\n          & img {\n            max-width: 90%;\n            max-height: ", ";\n          }\n        }\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        display: grid;\n        grid-template-rows: 30px auto max-content;\n\n        & .flexi-selector-checker {\n          text-align: right;\n          & i {\n            display: inline-flex;\n            width: 24px;\n            height: 24px;\n            color: #fff;\n            background: ", ";\n            border-radius: 50%;\n            align-items: center;\n            justify-content: center;\n            transform: scale(0);\n            transition: all 0.2s ease-out;\n          }\n        }\n        & .flexi-selector-icon {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          & i {\n            font-size: ", ";\n          }\n          & img,\n          svg {\n            height: ", ";\n          }\n        }\n        & .flexi-selector-label {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          padding: 10px 0;\n          & strong {\n            font-weight: normal;\n            transition: all 0.2s ease-out;\n          }\n        }\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  display: none;\n\n  & + label {\n    cursor: pointer;\n    display: block;\n    width: ", ";\n    height: ", ";\n    padding: 10px;\n    margin: 0;\n    border: 1px solid ", ";\n    border-radius: ", ";\n    transition: ", ";\n    color: ", ";\n    filter: grayscale(100%);\n    & svg {\n      fill: ", ";\n    }\n\n    ", "\n    ", "\n      ", "\n  }\n\n  &:active,\n  :focus {\n    outline: none;\n  }\n  &:hover {\n    & + label {\n      filter: grayscale(0);\n      border: 1px solid ", ";\n    }\n  }\n  &:disabled {\n    & + label {\n      border: 1px dashed ", ";\n      color: ", ";\n    }\n    &:hover {\n      & + label {\n      filter: grayscale(100%);\n      }\n    }\n  }\n  &:checked {\n    & + label {\n      filter: grayscale(0);\n      border: 1px solid ", ";\n      background: #fff;\n      ", ";\n      & .flexi-selector-label{\n        font-weight: bold;\n        color: ", ";\n      }\n      & .flexi-selector-checker {\n        & i {\n          transform: scale(1);\n          background: ", ";\n          border: none;\n          color: #fff;\n        }\n      }\n      & .flexi-selector-icon {\n        color: ", ";\n        & svg {\n          fill: ", ";\n        }\n      }\n\n      ", "\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    display: block;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  margin: ", ";\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SelectorWrapper = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.space;
}, function (props) {
  return (props.view === "label" || props.view === "custom") && (0, _styledComponents.css)(_templateObject2());
});

var SelectorInput = _styledComponents["default"].input.attrs(function (props) {
  return {
    type: props.type,
    className: "flexi-radio"
  };
})(_templateObject3(), function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.theme.PrimaryBorderColor;
}, function (props) {
  return props.theme.PrimaryRadius;
}, function (props) {
  return props.theme.PrimaryTransition;
}, function (props) {
  return props.theme.PrimaryFontColor;
}, function (props) {
  return props.theme.PrimaryFontColor;
}, function (props) {
  return props.view === "icon" && (0, _styledComponents.css)(_templateObject4(), function (props) {
    return props.color ? props.color : props.theme.PrimaryColor;
  }, function (props) {
    return props.iconSize;
  }, function (props) {
    return props.iconSize;
  });
}, function (props) {
  return props.view === "label" && (0, _styledComponents.css)(_templateObject5(), function (props) {
    return props.theme.PrimaryBorderColor;
  }, function (props) {
    return props.iconSize;
  });
}, function (props) {
  return props.view === "custom" && (0, _styledComponents.css)(_templateObject6(), function (props) {
    return props.theme.PrimaryBorderColor;
  }, function (props) {
    return props.iconSize;
  });
}, function (props) {
  return props.color ? props.color : props.theme.PrimaryColor;
}, function (props) {
  return props.theme.PrimaryBorderColor;
}, function (props) {
  return (0, _polished.transparentize)(0.6, props.theme.PrimaryFontColor);
}, function (props) {
  return props.color ? props.color : props.theme.PrimaryColor;
}, function (props) {
  return props.theme.Elevate.high;
}, function (props) {
  return props.color ? props.color : props.theme.PrimaryColor;
}, function (props) {
  return props.color ? props.color : props.theme.PrimaryColor;
}, function (props) {
  return props.color ? props.color : props.theme.PrimaryColor;
}, function (props) {
  return props.color ? props.color : props.theme.PrimaryColor;
}, function (props) {
  return props.view === "label" && (0, _styledComponents.css)(_templateObject7(), function (props) {
    return props.theme.Elevate.mid;
  });
});

var createUUID = function createUUID() {
  var s = [];
  var hexDigits = "0123456789abcdef";

  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }

  s[14] = "4";
  s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1);
  s[8] = s[13] = s[18] = s[23] = "-";
  var uuid = s.join("");
  return uuid;
};

var CardSelector = function CardSelector(props) {
  var children = props.children,
      space = props.space,
      other = _objectWithoutProperties(props, ["children", "space"]);

  var id = props.id ? props.id : createUUID();
  return /*#__PURE__*/_react["default"].createElement(SelectorWrapper, _extends({}, props, {
    className: "flexi-selector"
  }), /*#__PURE__*/_react["default"].createElement(SelectorInput, _extends({}, other, {
    id: id
  })), /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: id
  }, props.view === "icon" && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flexi-selector-checker"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "flexibull-ok"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flexi-selector-icon"
  }, props.icon && props.icon), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flexi-selector-label"
  }, props.label && props.label)), props.view === "label" && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flexi-selector-checker"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "flexibull-ok"
  })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flexi-selector-label"
  }, props.label && props.label), props.description && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flexi-selector-description"
  }, " ", props.description, " "))), props.view === "custom" && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flexi-selector-checker"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "flexibull-ok"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flexi-selector-label"
  }, props.label && props.label), props.children && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flexi-selector-children"
  }, props.children, " "))));
};

exports.CardSelector = CardSelector;
CardSelector.defaultProps = {
  type: "radio",
  view: "icon",
  size: "166px",
  iconSize: "30px",
  space: "5px"
};
CardSelector.propTypes = {
  block: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  checked: _propTypes["default"].bool,
  type: _propTypes["default"].string,
  view: _propTypes["default"].string,
  iconSize: _propTypes["default"].string,
  space: _propTypes["default"].string,
  color: _propTypes["default"].string,
  id: _propTypes["default"].string
};